<template>
  <div class="block" v-if="page.total > 0">
    <div class="left" v-if="reserve"
      >选中{{ selectLength }}条,显示第 {{ (page.pageNum - 1) * page.pageSize + 1 }} 条到
      {{
        (page.pageNum - 1) * page.pageSize + page.pageSize > page.total
          ? page.total
          : (page.pageNum - 1) * page.pageSize + page.pageSize
      }}
      条记录，共 {{ page.total }} 条记录</div
    >
    <div class="left" v-else
      >显示第 {{ (page.pageNum - 1) * page.pageSize + 1 }} 条到
      {{
        (page.pageNum - 1) * page.pageSize + page.pageSize > page.total
          ? page.total
          : (page.pageNum - 1) * page.pageSize + page.pageSize
      }}
      条记录，共 {{ page.total }} 条记录</div
    >
    <el-pagination
      v-if="page.total > 0"
      class="right"
      ref="page"
      background
      @size-change="handleSizeChange"
      @current-change="handlePagination"
      :page-count="page.pages"
      :current-page="page.pageNum || 1"
      :page-sizes="pageSizes"
      :page-size="page.pageSize"
      :total="page.total"
      layout="sizes, prev, pager, next, jumper"
    ></el-pagination>
  </div>
</template>

<script>
  export default {
    name: 'SiruiPagination',
    props: {
      //是否需要翻页选中
      reserve: {
        type: Boolean,
        default: true,
      },
      // 分页选择条数
      pageSizes: {
        type: Array,
        default: () => [10, 20, 50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 1000],
      },
      page: {
        type: Object,
        default: () => {
          return {
            pages: 1, //总共多少页
            pageNum: 1, //第几页
            pageSize: 10, //一页多少条数据
            total: 0, //总共多少条
          };
        },
      },
      selectLength: {
        type: Number,
        default: 0,
      },
    },
    data() {
      return {
        pageInfo: this.page,
      };
    },
    methods: {
      //抛出选择每页条数事件
      handleSizeChange(val) {
        //每次重新选择每页条数，都需要从第一页开始查询
        const page = {
          ...this.page,
          pageNum: 1,
          pageSize: val,
        };
        this.$emit('update:page', page);
        this.$emit('handleSizeChange', val);
      },
      handlePagination(val) {
        this.setPageNum(val);
        this.$emit('handleCurrentChange', val);
      },
      //设置每页显示10条
      setPageSize(val) {
        const page = {
          ...this.page,
          pageSize: val,
        };
        this.$emit('update:page', page);
      },
      setPagesCount(val) {
        const page = {
          ...this.page,
          pages: val,
        };
        this.$emit('update:page', page);
      },
      setPageNum(val) {
        const page = {
          ...this.page,
          pageNum: val,
        };
        this.$emit('update:page', page);
      },
      //设置总条数
      setPageTotal(val) {
        const page = {
          ...this.page,
          total: val,
        };
        this.$emit('update:page', page);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .block {
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .el-pagination {
      display: inline-block;
    }
    .left {
      color: #999999;
      font-size: 12px;
    }
    .right {
      ::v-deep .active:hover {
        color: #ffffff !important;
      }
    }
  }
</style>
